// src/components/scheduler/RatePlansField.jsx
import React from "react";
import { Box, Button, FormControl } from "@mui/material";
import CustomRatePlans from "../CustomRatePlans";

export default function RatePlansField({
  label = "Rate Plans",
  labelId = "rate-plans-select",
  options,               // array<string>
  value,                 // array<string>
  onChange,              // fn(array<string>)
}) {
  const allowed = React.useMemo(() => new Set(options || []), [options]);

  const safeApply = (arr) => {
    const next = (Array.isArray(arr) ? arr : [])
      .map((v) => (typeof v === "string" ? v : String(v ?? "")))
      .filter((v) => v && allowed.has(v));
    onChange(next);
  };

  return (
    <Box sx={{ display: "grid", gap: 1 }}>
      <FormControl fullWidth margin="dense">
        <CustomRatePlans
          selectedValue={value}
          setSelectedValue={safeApply}
          options={options}
          isFullWidth={true}
          label={label}
          handleSelectValue={safeApply}
          labelId={labelId}
        />
      </FormControl>
    </Box>
  );
}
